import React from "react";
import { isMockAuth, mockUser } from "./config";

export default function MockAuthBanner() {
  if (!isMockAuth) return null;
  return (
    <div
      data-testid="mock-auth-banner"
      className="fixed bottom-2 right-2 z-50 px-2 py-1 bg-yellow-600 text-yellow-50 text-xs font-mono rounded shadow-lg pointer-events-none select-none"
      title={`Mock auth active. Signed-in user: ${mockUser.email} (sub: ${mockUser.sub})`}
    >
      MOCK AUTH
    </div>
  );
}
